import { render } from "./object.vue?vue&type=template&id=d2f741b8&scoped=true"
import script from "./object.vue?vue&type=script&lang=js"
export * from "./object.vue?vue&type=script&lang=js"

import "./object.vue?vue&type=style&index=0&id=d2f741b8&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2f741b8"]])

export default __exports__